import React from 'react';
import {createDateList} from "../../simulationFunctions";

type Props = {
  dateStr: string;
  setDateStr: React.Dispatch<React.SetStateAction<string>>;
  setDateList: React.Dispatch<React.SetStateAction<string[]>>
}

const SimulationDateLabels: React.VFC<Props> = (props) => {
  return (
    <>
      <label htmlFor="">
        日付：
      </label>
      <input
        type="date"
        value={props.dateStr}
        onChange={(e:React.ChangeEvent<HTMLInputElement>)=>{
          props.setDateStr(e.target.value);
          props.setDateList(createDateList(e.target.value));
        }}
      />
    </>
  );
};

export default SimulationDateLabels;
